const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://ai-humanize-backend.onrender.com';

export default API_BASE_URL;
